export const REDIRECT_SIGN_IN_RESET = 'REDIRECT_SIGN_IN_RESET';
export const REDIRECT_SIGN_IN = 'REDIRECT_SIGN_IN';

export const REDIRECT_CORP_CHOOSE_RESET = 'REDIRECT_CORP_CHOOSE_RESET';
export const REDIRECT_CORP_CHOOSE = 'REDIRECT_CORP_CHOOSE';